module.exports = __webpack_public_path__ + "img/trend.ba29fa10.png";